import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'real-estate-developments-units',
  storeModule.createStoreModule('real-estate-developments-units')
)
